import React, { useState, useEffect } from 'react';
import { UserPlus, KeyRound, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';

// ⭐ Import your actual API utilities
import {
  API_BASE,
  DB_NAME,
  get,
  post,
  getAuthHeader,
} from "../../lib/api";

const AdminSignup = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [roleId, setRoleId] = useState('');
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // ===========================
  // FETCH ROLES
  // ===========================
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await get(`${API_BASE}/roles`, {}, DB_NAME);

        const rolesArray = Array.isArray(res.roles) ? res.roles : [];

        setRoles(rolesArray);
        if (rolesArray.length > 0) {
          setRoleId(rolesArray[0].id);
        }
      } catch (err) {
        console.error("Role fetch failed:", err.message);
        toast.error('Failed to load roles');
      }
    };

    fetchRoles();
  }, []);

  // ===========================
  // HANDLE SUBMIT
  // ===========================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      toast.error('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const payload = {
        username,
        email,
        password,
        role_id: roleId
      };

      const res = await post(`${API_BASE}/admin/signup`, payload, DB_NAME);

      toast.success('Admin account created successfully!');

      // Reset fields
      setUsername('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');

    } catch (err) {
      const msg = err.message || "Failed to create admin account.";
      console.error("Admin Signup Error:", msg);

      setError(msg);
      toast.error(msg);
    }

    setLoading(false);
  };

  // ===========================
  // UI
  // ===========================
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-green-100 py-12 px-4 sm:px-6 lg:px-8 font-serif flex items-center justify-center">
      <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 w-full max-w-md">

        <div className="text-center mb-6">
          <KeyRound className="w-12 h-12 text-green-700 mx-auto mb-2" />
          <h2 className="text-3xl font-bold text-gray-800">Admin Signup</h2>
          <p className="text-gray-500 mt-2">Create a new guardian account for the marketplace.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">

          {error && (
            <div className="bg-red-100 text-red-600 border border-red-300 rounded-xl p-4 text-center">
              {error}
            </div>
          )}

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            className="w-full px-5 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-green-500"
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-5 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-green-500"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-5 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-green-500"
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-5 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-green-500"
          />

          <select
            value={roleId}
            onChange={(e) => setRoleId(e.target.value)}
            className="w-full px-5 py-3 rounded-full border border-gray-300 focus:ring-2 focus:ring-green-500"
          >
            {roles.map((role) => (
              <option key={role.id} value={role.id}>{role.name}</option>
            ))}
          </select>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-4 rounded-full bg-green-600 text-white flex items-center justify-center gap-2 hover:bg-green-700 transition"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : <UserPlus size={20} />}
            {loading ? 'Creating...' : 'Sign Up'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default AdminSignup;
